module.exports = __webpack_public_path__ + "img/tj-fzcp-arrow-lh.3ca27962.png";